(function () {
  const obs = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('visible'), i * 90);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(r => obs.observe(r));

  // Email signup: wires footer + mid-page forms to Klaviyo
  const KLAVIYO_COMPANY_ID = 'UppkQF';
  const KLAVIYO_LIST_ID = 'XmPjhn';

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  async function subscribeToKlaviyo(email) {
    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } }
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
          }
        }
      })
    });
    if (!res.ok) throw new Error('subscribe failed');
  }

  function wireSignupForm(wrapSelector, inputSelector, buttonSelector) {
    document.querySelectorAll(wrapSelector).forEach(wrap => {
      if (wrap.dataset.wavaeWired) return;
      wrap.dataset.wavaeWired = '1';
      const input = wrap.querySelector(inputSelector);
      const button = wrap.querySelector(buttonSelector);
      if (!input || !button) return;
      const originalLabel = button.textContent;

      async function submit() {
        const email = input.value.trim();
        if (!isValidEmail(email)) {
          input.style.borderColor = '#c0392b';
          input.placeholder = 'Enter a valid email';
          return;
        }
        button.disabled = true;
        button.textContent = '...';
        try {
          await subscribeToKlaviyo(email);
          input.value = '';
          input.disabled = true;
          input.placeholder = "You're in. Check your inbox";
          button.textContent = 'Joined';
        } catch (err) {
          button.disabled = false;
          button.textContent = originalLabel;
          input.style.borderColor = '#c0392b';
          input.placeholder = 'Something went wrong. Try again';
        }
      }

      button.addEventListener('click', submit);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') submit(); });
    });
  }

  wireSignupForm('.email-row', 'input[type="email"]', 'button');
  wireSignupForm('.footer-email', 'input[type="email"]', 'button');

  // ── Mobile menu ──
  window.toggleMobileMenu = function () {
    const menu = document.getElementById('mobileMenu');
    const burger = document.getElementById('navBurger');
    if (!menu) return;
    const isOpen = menu.classList.toggle('open');
    if (burger) {
      burger.classList.toggle('open', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  };
  window.closeMobileMenu = function () {
    const menu = document.getElementById('mobileMenu');
    const burger = document.getElementById('navBurger');
    if (menu) menu.classList.remove('open');
    if (burger) { burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }
  };

  // ── Search overlay + predictive search ──
  let searchDebounce;

  window.toggleSearch = function () {
    const overlay = document.getElementById('searchOverlay');
    if (!overlay) return;
    const isOpen = overlay.classList.toggle('open');
    if (isOpen) {
      window.closeMobileMenu();
      const input = document.getElementById('searchInput');
      setTimeout(() => { if (input) input.focus(); }, 50);
    }
  };

  function renderSearchResults(items, query) {
    const box = document.getElementById('searchResults');
    if (!box) return;
    if (!query) { box.innerHTML = '<p class="search-hint">Start typing to search products.</p>'; return; }
    if (!items.length) { box.innerHTML = '<p class="search-empty">No results for &ldquo;' + query + '&rdquo;.</p>'; return; }
    let html = items.map(p => {
      const img = (p.image && (p.image.url || p.image)) || p.featured_image || '';
      let price = '';
      if (typeof p.price === 'number') {
        price = '£' + (p.price / 100).toFixed(2);
      } else if (typeof p.price === 'string' && p.price) {
        price = /[£$€]/.test(p.price) ? p.price : '£' + p.price;
      }
      return '<a class="search-result-item" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="">' : '') +
        '<div><div class="sr-title">' + p.title + '</div><div class="sr-price">' + price + '</div></div>' +
        '</a>';
    }).join('');
    html += '<a class="search-view-all" href="/search?q=' + encodeURIComponent(query) + '">View all results</a>';
    box.innerHTML = html;
  }

  function runPredictiveSearch(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
      .then(r => r.json())
      .then(data => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderSearchResults(products, query);
      })
      .catch(() => renderSearchResults([], query));
  }

  document.addEventListener('DOMContentLoaded', () => {
    const input = document.getElementById('searchInput');
    if (!input) return;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(searchDebounce);
      if (!q) { renderSearchResults([], ''); return; }
      searchDebounce = setTimeout(() => runPredictiveSearch(q), 280);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
      }
      if (e.key === 'Escape') window.toggleSearch();
    });
  });
})();
